var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import clsx from 'clsx';
import React, { forwardRef } from 'react';
import { alpha, makeStyles } from '@material-ui/core/styles';
import { TextField } from '@material-ui/core'; // ----------------------------------------------------------------------

var useStyles = makeStyles(function (theme) {
  return {
    textField: {
      marginTop: theme.spacing(-1),
      '& .MuiOutlinedInput-root': {
        '& fieldset': {
          borderColor: 'transparent'
        }
      },
      '& .MuiOutlinedInput-root:hover': {
        '& fieldset': {
          borderColor: alpha(theme.palette.primary.main, 0.48)
        }
      },
      '& .MuiInputBase-input': {
        marginTop: '7px'
      }
    }
  };
});
export var HeaderTextField = forwardRef(function (_a, ref) {
  var className = _a.className,
      other = __rest(_a, ["className"]);

  var classes = useStyles();
  return React.createElement(TextField, Object.assign({
    ref: ref,
    size: 'small',
    className: clsx(classes.textField, className)
  }, other));
});